export const yeuCauSuaChua = {
  sections: {
    list: { title: 'Repair requests' },
    listHang: { title: 'Repair requests' },
    detail: { title: 'Repair request detail' },
    payment: { title: 'Payment information' },
    services: { title: 'Repair & replacement services' },
  },
  aria: {
    columnPicker: 'Choose visible columns',
  },
  titles: { add: 'Create request', edit: 'Edit request' },
  tabs: {
    giaoDich: 'Transactions',
    hangSuaChua: 'Details',
    info: 'Information',
    services: 'Repair services',
    baoCao: 'Report',
  },
  columns: {
    code: 'Code',
    summary: 'Summary',
    status: 'Status',
    ngayTao: 'Created at',
    ngayCapNhat: 'Updated',
    maYeuCau: 'Request code',
    thoiGian: 'Time',
    khachHang: 'Customer',
    khachCanTra: 'Customer owes',
    khachDaTra: 'Customer paid',
    maHang: 'Item code',
    tenHang: 'Item name',
    serialImei: 'Serial / IMEI',
    loaiYeuCau: 'Request type',
    trangThaiSuaChua: 'Repair status',
    ngayHenTraKhach: 'Return date',
    ngayHoanThanh: 'Completed date',
    tongPhi: 'Total fee',
    ghiChuHang: 'Item note',
    donGia: 'Unit price',
    giamGia: 'Discount',
    giaBan: 'Sale price',
    thanhTien: 'Amount',
    nguoiNhan: 'Receiver',
    noiTiepNhan: 'Receive place',
    bangGia: 'Price list',
    chiNhanh: 'Branch',
    soLuong: 'Quantity',
    ghiChu: 'Note',
    note: 'Note',
    maHoaDon: 'Invoice code',
    maPhieuXuatKho: 'Stock-out code',
    ngayNhan: 'Received date',
    ngayTra: 'Returned date',
    nguoiNhanTra: 'Returned to',
    noiDungBaoLoi: 'Reported issue',
    ngayBaoLoi: 'Issue reported date',
    ngayLenHoaDonLinhKien: 'Parts invoice date',
    ngayCoLinhKien: 'Parts available date',
    tinhTrangTra: 'Return status',
    ketQuaChotKhach: 'Customer decision',
    lyDoKetThuc: 'Closing reason',
    ngayTraTongHop: 'Returned date (fully returned)',
    ngayTraTongHopHint: 'Auto-derived once every item is returned — date and receiver of the last return.',
    ngayLap: 'Created on',
    model: 'Model',
    ngayChotKhach: 'Customer decision date',
    ghiChuSuaChua: 'Repair note',
  },
  status: {
    dangXuLy: 'Processing',
    hoanThanh: 'Completed',
    daHuy: 'Canceled',
  },
  trangThai: {
    dangXuLy: 'Processing',
    hoanThanh: 'Completed',
    daHuy: 'Canceled',
  },
  trangThaiSuaChua: {
    daNhan: 'Received',
    dangXuLy: 'Processing',
    sanSangTraKhach: 'Ready to return',
    hoanThanh: 'Completed',
  },
  loaiYeuCau: {
    suaChuaDichVu: 'Repair service',
    yeuCauBaoHanhSP: 'Product warranty request',
    baoHanhDinhKy: 'Periodic maintenance',
  },
  ketQuaChotKhach: {
    chuaChot: 'Pending decision',
    dongYSua: 'Approved repair',
    khongSua: 'Declined repair',
  },
  lyDoKetThuc: {
    suaXong: 'Repair completed',
    khachKhongSua: 'Customer declined',
    khongCoLinhKien: 'No spare parts',
    khongThayLoi: 'No fault found',
  },
  filter: {
    searchPlaceholder: 'Search by request code',
    textDetailTitle: 'Advanced filters',
  },
  filters: {
    maKhachHang: 'Customer code',
    tenKhachHang: 'Customer name',
    hintSection: 'Tips',
    hintBody: 'Switch tab to change list view.',
    statusAll: 'All',
    maHang: 'Item code',
    tenHang: 'Item name',
    sectionStatus: 'Status',
    sectionStatusSC: 'Repair status',
    sectionType: 'Request type',
    sectionTime: 'Created time',
    sectionTimeBaoCao: 'Time',
    sectionUpdatedTime: 'Updated time',
    sectionReturnDate: 'Return date',
    sectionCompletedDate: 'Completed date',
    sectionTrangThaiTra: 'Return status',
    sectionKetQuaChot: 'Customer decision',
    sectionLyDoKetThuc: 'Closing reason',
    sectionGiaiDoan: 'Processing stage',
    sectionKyThuatVien: 'Technician',
    kyThuatVienAll: 'All',
    chuaPhanCong: 'Unassigned',
    daTra: 'Returned',
    chuaTra: 'Not returned',
    dateRangePlaceholder: 'Select date range',
    from: 'From',
    to: 'To',
    allTime: 'All time',
  },
  form: {
    code: 'Request code',
    codeAuto: 'Leave blank to auto-generate',
    customer: 'Customer',
    receiver: 'Receiver',
    creator: 'Created by',
    createdAt: 'Created at',
    receivePlace: 'Receive place',
    noiTiepNhanCuaHang: 'In store',
    noiTiepNhanTaiNha: 'At home',
    noiTiepNhanKhac: 'Other',
    datShip: '3rd-party shipping',
    deliveryPartner: 'Shipping partner',
    serviceType: 'Service type',
    maVanDon: 'Tracking no.',
    receiverName: 'Recipient',
    receiverPhone: 'Phone',
    deliveryAddress: 'Delivery address',
    deliveryFee: 'Shipping fee',
    priceList: 'Price list',
    note: 'Note',
    lines: 'Repair items',
    addLine: 'Add line',
    product: 'Item',
    productSearch: 'Search code / name',
    requestType: 'Request type',
    typeRepair: 'Repair service',
    typeWarranty: 'Warranty',
    serial: 'Serial / IMEI',
    password: 'Device password',
    matKhau: 'Device password',
    qty: 'Quantity',
    returnDate: 'Return date',
    lineNote: 'Line note',
    retailCustomer: 'Retail customer',
    discount: 'Discount',
    customerPaid: 'Customer paid',
    totalGoods: 'Total goods',
    customerMustPay: 'Customer must pay',
    stillOwed: 'Still owed',
    // POS-only fields (layout 1.PNG)
    customerSearch: 'Find customer (F4)',
    serialImei: 'Serial/IMEI/Plate',
    model: 'Model',
    modelPlaceholder: 'Enter machine model',
    returnDatePos: 'Return to customer',
    ngayNhan: 'Received date',
    ngayTra: 'Returned date',
    nguoiNhanTra: 'Returned to',
    ngayBaoLoi: 'Issue reported date',
    noiDungBaoLoi: 'Reported issue',
    ngayLenHoaDonLinhKien: 'Parts invoice',
    ngayCoLinhKien: 'Parts available',
    ketQuaChotKhach: 'Customer decision',
    lyDoKetThuc: 'Closing reason',
    lyDoKetThucHint: 'Only for completed items — leave blank to auto-derive from customer decision',
    ngayTraHang: 'Returned date',
    nguoiNhanTraHang: 'Returned to',
    trangThai: 'Status',
    loaiYeuCau: 'Request type',
    tongPhi: 'Total fee',
    soLuong: 'Quantity',
    kyThuatVien: 'Technician',
    ghiChuDon: 'Order note',
    ghiChuDichVu: 'Parts / service note',
    notePlaceholder: 'Note',
    chonKyThuat: '--- Select ---',
    bangGiaDefault: 'Default price list',
    pickDichVu: 'Search replacement goods',
    emptyDichVuHint: 'No services yet — search above to add',
    sectionThietBi: 'Device',
    sectionXuLy: 'Handling',
    itemExpand: 'Expand',
    itemCollapse: 'Collapse',
    sectionBaoLoi: 'Issue & closing',
    sectionLinhKien: 'Parts & return',
    noiDungBaoLoiPlaceholder: 'Describe the reported issue…',
    sectionDichVu: 'Replacement goods',
    maHangCol: 'Item code',
    tenHangCol: 'Item name',
    ghiChuCol: 'Note',
    hinhAnhToggle: 'Add device photos',
    hinhAnhCount: '{n} photos',
    dichVuCount: '{n} lines',
    customerPayment: 'Customer pays',
    paymentMethod: 'Payment method',
    paymentCash: 'Cash',
    paymentTransfer: 'Transfer',
    paymentCard: 'Card',
    paymentWallet: 'Wallet',
    tienThua: 'Change',
    conCanTra: 'Still owed',
    thuKhac: 'Other fee',
    donVi: 'Unit',
    donGia: 'Unit price',
    giaBan: 'Sale price',
    editPrice: 'Edit sale price',
    discountPercent: 'Disc (%)',
    byAmount: 'By amount',
    byPercent: 'By %',
    priceBelowCost: 'Sale price is below cost',
    discountCellHint: 'Enter an amount, or add % for a percentage discount (e.g. 10%)',
    dichVuColumnSettings: 'Show / hide columns',
    dichVuColumnReset: 'Reset to default',
    dichVuColumnLocked: 'Required column, cannot be hidden',
    thanhTien: 'Subtotal',
    dichVuHangHoa: 'Replacement goods',
    modelEmpty: 'Device under repair',
    hangHoaEmpty: 'Repair item',
    hangHoaEmptyHint: 'Use the top search box (F3) to add a product to the repair list.',
    pickHangHoaSua: 'Find product (F3)',
    addHangHoa: 'Add new product',
    addDichVu: 'Add service',
    noiTiepNhanLabel: 'In store',
    save: 'SAVE',
    taoHoaDon: 'CREATE INVOICE',
    hinhAnhHang: 'Repair item photos',
    hinhAnhAdd: 'Add photo',
    hinhAnhPaste: 'Paste photo',
    hinhAnhUploading: 'Uploading photo',
    hinhAnhSetMain: 'Set as main photo',
    hinhAnhMain: 'Main',
    hinhAnhHint: 'Up to 5 photos (first is the main photo).',
    hinhAnhDragDrop: 'Drop photos here',
  },
  fields: {
    totalAmount: 'Total',
    totalGoods: 'Total goods',
    discount: 'Discount',
    customerMustPay: 'Customer owes',
    customerPaid: 'Customer paid',
    stillOwed: 'Still owed',
  },
  messages: {
    loadError: 'Could not load list.',
    deleteSuccess: 'Deleted.',
    createSuccess: 'Repair request created.',
    updateSuccess: 'Repair request updated.',
    needLines: 'Please add at least one repair item.',
    soLuongThietBiMin: 'Received device quantity must be at least 1.',
    traTatCaChuaXong: 'Some devices are not finished repairing — cannot return all.',
    traTatCaCanNguoiNhan: 'Please select who receives the return.',
    noData: 'No data.',
    noLines: 'No lines.',
    noServices: 'No repair services.',
    listSummary: 'Total {count}',
    processSuccess: 'Started processing request.',
    taoHoaDonSuccess: 'Invoice created from repair request.',
    taoHoaDonError: 'Failed to create invoice.',
    phieuXuatKhoFromRepair: 'Sales out from repair request {code}',
    completeSuccess: 'Repair request completed.',
    cancelSuccess: 'Repair request canceled.',
    exportSuccess: 'File exported.',
    exportError: 'Export failed.',
    printSuccess: 'Print requested.',
    confirmCancel: 'Cancel this request?',
    confirmComplete: 'Complete this request?',
    confirmTraHang: 'Confirm returning goods to customer?',
    traHangSuccess: 'Goods returned to customer.',
    confirmTraHangRows: 'Return {n} unreturned items to customer?',
    traHangCanhBaoChuaXong: '{n} items not yet repaired are still being returned.',
    traHangChuaXong: 'Return this item even though it is not repaired yet?',
    traHangGiaTriCu: 'Current: {ngay} · {nguoi}',
    traHangOverwriteConfirm: 'This overwrites the previous return record — the change is audit-logged (old → new). Continue?',
    traHangXacNhanGhiDe: 'Overwrite',
    traHangDaTra: 'Returned',
    traHangThietBi: 'Return device',
    xoaNgayTraPhieuCanhBao: 'Removing the request return date also removes the return date of ALL items. Continue?',
    hinhAnhUploadError: 'Failed to upload photo.',
  },
  actions: {
    process: 'Process',
    complete: 'Complete',
    cancelVoucher: 'Cancel',
    export: 'Export',
    print: 'Print',
    save: 'Save',
    taoPhieuXuatKho: 'Create stock-out voucher',
    traHang: 'Return goods',
    traTatCa: 'Return all',
    suaThongTinTra: 'Edit return info',
  },
  placeholders: {
    formTitle: 'Create / edit repair request',
    formBody: 'Full form will be added later.',
  },
  pos: {
    addTab: 'Add repair request tab',
    tabTitle: 'Repair {n}',
    tabEdit: 'Edit {code}',
    tabClone: 'Clone {code}',
    history: 'Repair request history',
    confirmCloseTitle: 'Close this tab?',
    confirmCloseBody: 'This tab has unsaved changes. Closing it will discard them.',
    newTabYeuCauSuaChua: 'New repair request',
    openEdit: 'Open edit tab',
    openClone: 'Clone',
    saved: 'Repair request saved.',
    status: 'Status',
    statusAll: 'All',
    statusYeuCauSuaChua: 'Repair request',
  },
  giaiDoan: {
    tatCa: 'All (excluding cancelled)',
    chuaXong: 'Not completed',
    choKhachChot: 'Awaiting customer decision',
    dangSua: 'Repairing',
    khongSuaChoDong: 'Declined, not closed',
    daXong: 'Completed',
    choTraKhach: 'Done, awaiting return',
    daTra: 'Returned to customer',
    chuaTra: 'Not returned',
    quaHan: 'Overdue return',
  },
  baoCao: {
    thoiGian: 'Period (request created)',
    duAn: 'Project',
    duAnHienTai: 'current',
    kyThuatVien: 'Technician',
    tatCaKtv: 'All technicians',
    khongCoKtv: 'No technicians found',
    chuaPhanCong: 'Unassigned',
    bieuDoTheo: 'Chart by',
    ngay: 'Day',
    tuan: 'Week',
    thang: 'Month',
    kyTuan: 'Week {w}/{y}',
    kyThang: 'Month {m}/{y}',
    kyNam: 'Year {y}',
    tyLeXong: '% done',
    tyLeTra: '% returned',
    tyLeXongLine: '% done',
    chartKtv: 'Technician workload',
    chartKtvHint: 'Assigned items by repair status',
    chartKtvTop: 'Top {n} by items',
    chartKtvChuaPhanCong: '{n} unassigned items',
    phamVi: '{tu} – {den} · {n} project(s)',
    lamMoi: 'Refresh',
    thuLai: 'Retry',
    loadError: 'Could not load the report.',
    empty: 'No repair requests in this period.',
    moDanhSach: 'Click to open the item list',
    phieuSuaXongChuaTra: 'Not fully returned',
    phieuSuaXongChuaTraHint: 'Request has at least one unreturned item',
    khacDuAnHint: 'Viewing several projects: only figures of the current project can open the list.',
    tongDon: 'Total requests',
    tongSp: 'Total items',
    daXong: 'Completed',
    chuaXong: 'Not completed',
    daTraKhach: 'Returned',
    chuaTraKhach: 'Not returned',
    choTraKhach: 'Done, awaiting return',
    nhomSuaChua: 'Repair',
    nhomTraKhach: 'Return',
    kpiTongDonSub: 'Not cancelled · {n} project(s)',
    kpiTongSpSub: 'Avg {n} items/request',
    kpiPctSub: '{pct} of items',
    kpiTreHenSub: '{n} overdue',
    kpiKhongTreHen: 'Nothing overdue',
    kpiChuaTraSub: 'Incl. {n} done, awaiting pickup',
    bangTongHop: 'Summary',
    bangKtvThang: 'Technician by month',
    bangTheoLoai: 'By request type',
    chiTietKtv: 'Technician detail',
    duAnCot: 'Project',
    nam: 'Year',
    thangCot: 'Month',
    caThang: 'Whole month',
    congDuAn: 'Total {ten}',
    tongCong: 'Grand total',
    congTong: 'Total',
    tong: 'Total',
    chiSo: 'Metric:',
    loaiYeuCau: 'Request type',
    chuaPhanLoai: 'Unclassified',
    chartTienDo: 'Progress by intake period',
    chartTienDoHint: 'Current stage of items received in each period',
    chartKetQua: 'Outcome',
    chartKetQuaHint: 'Completed items by closing reason',
    chartKetQuaEmpty: 'No completed items yet',
    ketQua: {
      suaXong: 'Repaired',
      khachKhongSua: 'Customer declined',
      khongCoLinhKien: 'No spare parts',
      khongThayLoi: 'No fault found',
      chuaRoLyDo: 'No reason recorded',
    },
  },
}
